var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { Box, TextField, Button, Typography, CircularProgress, Alert } from '@mui/material';
import { useAuth } from './AuthContext';
import { useNotification } from '../context/NotificationContext';
export const PasswordResetForm = ({ onSuccess, onError, onCancel }) => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [resetSent, setResetSent] = useState(false);
    const { sendPasswordResetEmail } = useAuth();
    const { showNotification } = useNotification();
    // Show error notification when there's an error
    const prevErrorRef = useRef(null);
    useEffect(() => {
        if (error && error !== prevErrorRef.current) {
            prevErrorRef.current = error;
            showNotification({
                message: error,
                severity: 'error'
            });
            // Also call the onError callback if provided
            if (onError) {
                onError(new Error(error));
            }
        }
    }, [error, showNotification, onError]);
    const handleSubmit = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        setError(null);
        if (!email) {
            setError('Please enter your email address');
            return;
        }
        try {
            setLoading(true);
            yield sendPasswordResetEmail(email);
            setResetSent(true);
            showNotification({
                message: 'Password reset email sent. Please check your inbox.',
                severity: 'success'
            });
            if (onSuccess) {
                onSuccess();
            }
        }
        catch (err) {
            setError(err.message || 'Failed to send password reset email');
        }
        finally {
            setLoading(false);
        }
    });
    return (_jsxs(Box, { component: "form", onSubmit: handleSubmit, noValidate: true, children: [_jsx(Typography, { variant: "h6", component: "h2", gutterBottom: true, children: "Reset Password" }), resetSent ? (_jsxs(Box, { sx: { my: 2 }, children: [_jsxs(Alert, { severity: "success", sx: { mb: 2 }, children: ["Password reset email has been sent to ", email, ". Please check your inbox and follow the instructions to reset your password."] }), _jsx(Button, { fullWidth: true, variant: "outlined", onClick: onCancel, sx: { mt: 1 }, children: "Back to Login" })] })) : (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 2 }, children: "Enter your email address and we'll send you a link to reset your password." }), _jsx(TextField, { margin: "normal", required: true, fullWidth: true, id: "email", label: "Email Address", name: "email", autoComplete: "email", autoFocus: true, value: email, onChange: (e) => setEmail(e.target.value), disabled: loading }), _jsxs(Box, { sx: { display: 'flex', gap: 1, mt: 3 }, children: [_jsx(Button, { type: "submit", fullWidth: true, variant: "contained", disabled: loading, children: loading ? _jsx(CircularProgress, { size: 24 }) : 'Send Reset Link' }), _jsx(Button, { fullWidth: true, variant: "outlined", onClick: onCancel, disabled: loading, children: "Cancel" })] })] }))] }));
};
